export class VaultStatusFilters {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "_in",
            "baseName": "in",
            "type": "Array<VaultStatus>",
            "format": ""
        },
        {
            "name": "notIn",
            "baseName": "notIn",
            "type": "Array<VaultStatus>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return VaultStatusFilters.attributeTypeMap;
    }
    constructor() {
    }
}
